import React from 'react'

import { Image } from '@/components/atoms/Image/Image'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import { LandingPageSectionType } from './types'

export function LandingPageSection({ title, description, sub_title, images }: LandingPageSectionType) {
  return (
    <section className="relative max-w-screen-desktop mx-auto p-24 pt-0 laptop:px-90 laptop:pb-64  w-full flex flex-col justify-center items-center">
      <h2 className="font-poppins text-headingS-mobile netbook:text-headingS font-bold mb-12 netbook:mb-32 text-center">
        {title}
      </h2>
      {description && (
        <Paragraph className="text-bodyL text-text-dark-900 netbook:w-3/4 mb-20 text-center">{description}</Paragraph>
      )}
      {sub_title && <p className="leading-10 hidden netbook:inline-flex">{sub_title}</p>}
      {images && (
        <div className="flex items-center flex-wrap justify-around netbook:justify-center netbook:space-x-20 filter grayscale w-full netbook:w-3/4 mt-32 mb-32 netbook:mb-0">
          {images?.map((img) => <Image fixed data={img.image} key={img._uid} imgClassName="mb-8 tablet:mb-0" />)}
        </div>
      )}
    </section>
  )
}
